"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumericInput = NumericInput;
var _react = _interopRequireDefault(require("react"));
var _reactHookForm = require("react-hook-form");
var _material = require("@mui/material");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function NumericInput({
  control,
  field,
  label,
  errors,
  sx = {
    width: 300
  }
}) {
  const hasError = Boolean(errors) && Boolean(errors[field]);
  return /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    name: field,
    control: control,
    render: ({
      field: {
        onChange,
        value = '',
        ...rest
      }
    }) => {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_material.TextField, _extends({
        id: field.replaceAll('_', '-') + '-input',
        onChange: onChange,
        value: value,
        label: label,
        inputProps: {
          inputMode: 'numeric',
          pattern: '[0-9]*'
        },
        size: "small",
        sx: sx,
        placeholder: "Numberic value",
        onInvalid: e => {
          e.target.setCustomValidity('Please enter a number');
        }
      }, hasError ? {
        error: true
      } : {}, {
        helperText: hasError ? errors[field].message : ''
      })));
    }
  });
}